/*
 *   File : risk-profile-status.js
 *   Author : https://evoqins.com
 *   Description : Risk profile status modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useState } from 'react';
import { toast } from 'react-toastify';

// Assets
import RiskProfileMisMatch from "../../Assets/Images/Modal/risk-profile-mismatch.webp";

//Custom components
import { PrimaryButton } from '../Buttons';
import SecondaryButton from '../Buttons/secondary-button';
import { APIService } from '../../Service';

const RiskProfileStatusModal = (props) => {

    const [loading, setLoading] = useState();

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("risk-profile-status-modal-close");
        button.click();
    };

    // handle success
    const _handleContinue = () => {
        if (props.type === 2) {
            // API call
            _saveRiskMismatchConsent();
        } else {
            _handleCloseModal();
            props.handleContinue();
        }
    };

    // handle success
    const _handleRetake = () => {
        _handleCloseModal();
        props.handleRetake();
    };


    // ============  API CALL ============== //

    // API to save user risk mismatch consent 
    const _saveRiskMismatchConsent = async () => {

        setLoading(true);

        let risk_mismatch_content = `Your Risk Profiling is ${props.riskData.risk_category_name} as per the assessment undertaken by you which is not aligned with the investment objectives. You can retake the assessment to change your risk profile or click on PROCEED whereby you proceed to invest in this product category understanding the risk involved.`;
        let url = "profile/save-consent";
        let data = {
            "content": risk_mismatch_content,
            "consent_type": "RISK_MISMATCH",
            "content_flag": true,
            "otp": null,
            "source": "WEB",
            "strategy_id": props.data.strategyID,
            "tenant_id": props.data.tenantID,
            "user_id": props.data.userID
        };

        const response = await APIService(url, data);

        if (response.status_code === 200) {
            _handleCloseModal();
            props.handleContinue();
        } else {
            toast.dismiss();
            toast.error(response.message);
        }

        setLoading(false);
    };

    return (
        <div className="modal fade"
            id="risk-profile-status-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="subscriptionModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5`}>
                <span id='risk-profile-status-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 overflow-hidden border-0 mx-lg-5">
                    <div className='modal-body px-3 py-4 text-center'>
                        <img src={RiskProfileMisMatch}
                            draggable={false}
                            width={200}
                            alt='risk profile mismatch image' />

                        <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                            {
                                props.type === 1 ? "Successfully Completed the Risk Profile" : "Risk Profile Mismatch"
                            }
                        </h4>
                        {
                            props.type === 1 ?
                                <div>
                                    <p className='e-alt-font-lato e-font-18 e-text-outer-space e-font-weight-600 line-height-20px mb-3 mt-3'>
                                        Basket Risk type : {props.basketRiskInfo.risk_category_name}
                                    </p>
                                    <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                                        {/* Based on a risk score, {props.riskData.riskCategoryDescription} */}
                                        Your risk profile is {props.riskData.risk_category_name} as per the assessment undertaken by you
                                    </p>
                                </div>
                                :
                                <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                                    Your Risk Profiling is<span className='px-1 e-font-weight-600'>{props.riskData.risk_category_name}</span>as per the assessment undertaken by you which is
                                    not aligned with the investment objectives. You can retake the assessment to change your risk profile
                                    or click on PROCEED whereby you proceed to invest in this product category understanding the risk involved.
                                </p>
                        }
                    </div>
                    {/* Modal footer */}
                    <div className='modal-footer border-0 px-3 pb-3'>
                        <div className="d-flex w-100 gap-2">
                            {
                                props.type !== 1 &&
                                <SecondaryButton name={"Retake"}
                                    className="h-48 flex-1 w-50"
                                    onPress={_handleRetake} />
                            }
                            <PrimaryButton name="Proceed"
                                status={loading}
                                disabled={loading}
                                className="h-48 flex-1 w-50 ms-auto flex-fill"
                                onPress={_handleContinue} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

RiskProfileStatusModal.defaultProps = {
    handleClose: () => { },
};

export default memo(RiskProfileStatusModal);
